import React from "react";
import { Row, Col } from "antd";

import { Container, CustomCard } from "./styled";
import { cards } from "./_cards";

const CardSection = () => (
  <Container>
    <Row justify={"center"} gutter={{ xs: 0, sm: 32, md: 24, lg: 24,}}>
      {cards.map((card, key) => (
        <Col key={key} xs={14} sm={11} md={10} lg={9}>
          <CustomCard
            type={card.type}
            title={card.title}
            imgSrc={card.imgSrc}
            content={card.content}
            contentTitle={card.contentTitle}
            btnText={card.btnText}
            bptop="20px"
            url={card.href}
          />
        </Col>
      ))}
    </Row>
  </Container>
);

export default CardSection;
